import axios from 'axios';
import ApiURLs from '@/ApiURLs';
 
class FileService {
    convertFile(data: any) {
        return axios.put(ApiURLs.convertFile, data);
    }
}

export default new FileService();